// extracted by mini-css-extract-plugin
module.exports = {"card":"ProjectCard_card__S1Yjd","image":"ProjectCard_image__XTXX5","mobileCarouselDisabledCard":"ProjectCard_mobileCarouselDisabledCard__o8x5d","title":"ProjectCard_title__XQV9H"};